import { useMemo } from "react";
import { ImageUploader } from "./ImageUploader";
import { CompanyMediaPreview } from "./CompanyMediaPreview";

export function CompanyCoverField({ companyId, file, existingUrl, removed, onChange, onRemove, onUndo }: {
  companyId: string;
  file: File | null;
  existingUrl: string;
  removed: boolean;
  onChange: (file: File | null) => void;
  onRemove: () => void;
  onUndo: () => void;
}) {
  const images = useMemo(() => file ? [file] : [], [file]);
  return <div>
    <p className="label">Business cover photo (optional)</p>
    <ImageUploader value={images} onChange={files => onChange(files[0] || null)} min={0} max={1} mediaKind="cover" layout="dropzone" example="Add a wide photo of your team, workplace or work. Saved when you continue." />
    {!file && existingUrl && !removed && <div className="mt-3 space-y-2">
      <CompanyMediaPreview companyId={companyId} kind="cover" revision={existingUrl} alt="Current business cover photo" className="aspect-[3/1] w-full max-w-xl rounded-lg border border-line object-cover" />
      <button type="button" className="btn-ghost text-sm" onClick={onRemove}>Remove current cover photo</button>
    </div>}
    {!file && <p className="mt-2 text-xs text-mut">{removed ? "The default industry image will return when you save." : "Without a cover photo, we'll use an image for your industry."} {removed && existingUrl && <button type="button" className="underline font-semibold" onClick={onUndo}>Undo removal</button>}</p>}
  </div>;
}
